export default __webpack_public_path__ + "static/media/alternative_finance-dk.d2c6a094.svg";